exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.subitem-wrapper[data-v-45081e96]:before,\n.subitem-wrapper[data-v-45081e96]:after {\n    margin: auto;\n    content: '';\n}\n", ""]);

// exports
